import React from 'react';

const leaderboards = [
{
	title1: 'Équipes',
	title2: 'Différentiel par ronde',
	imgPath: '/img/qi2023-s01a.png',
	imgSize: 200
},
{
	title1: 'Joueurs',
	title2: 'IPS par catégorie',
	imgPath: '/img/qi2023-s02a.png',
	imgSize: 300
},
];

class QuebecInvLeaderboards2023 extends React.Component {

  constructor(props) {
		super(props);
		//this.dummyfunction = this.dummyfunction.bind(this);
	}

	render() {
		return (
			<div className="animated fadeIn">
      <div className="row">
      <div className="col-md-12 col-xs-12">
        <h4>QVNEA - Québec Invitations 2023 - Classements des Leaders</h4>
        <p>Cliquer sur les images pour les agrandir</p><br/>
      </div>
      </div>

      <div className="row">
				{this.dispLeaderboard(0)}
				{this.dispLeaderboard(1)}
      </div>

      <div className="row">
      <div className="col-md-12 col-xs-12">
				<a href="http://facebook.com/StateloStats" target="_blank">
          <img className="img-fluid" src="/img/suivez-facebook-01b.png" alt="suivez-nous" width="300"/>
				</a>
				<p><b>Profitez-en pour Aimer la page facebook de Statelo ! </b></p>
      </div>
      </div>
      </div>
		);
	}

	dispLeaderboard(idx) {
		return (
     	<div className="col-md-3 col-xs-12">
	      <p><b>{leaderboards[idx].title1}<br/>{leaderboards[idx].title2}</b></p>
	      <a href={leaderboards[idx].imgPath}>
					<img className="img-fluid" src={leaderboards[idx].imgPath} alt={leaderboards[idx].title2} width={leaderboards[idx].imgSize}/><br/><br/>
				</a>
    	</div>
		);
	}

}

export default QuebecInvLeaderboards2023;